<template>
  <v-container class="py-0 px-5">
    <v-btn v-if="!open_edit" @click="openEdit()">
      {{ $t('share_editing_plane') }}
    </v-btn>
    <v-form v-if="open_edit">
      <v-card>
        <v-list-item>
          <v-row>
            <v-col
              cols="12"
            >
              <data-selector
                v-model="editedItem.organization_id"
                autofocus
                field-name="organizations"
                source-type="organizations"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <date-field
                v-model="editedItem.start_date"
                field-name="share_start_date"
                rules="required|date"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <date-field
                v-model="editedItem.end_date"
                field-name="share_end_date"
                rules="required|date"
              />
            </v-col>
          </v-row>
        </v-list-item>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="cancel"
            min-width="90"
            class="mx-1"
            @click="closeEdit()"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="save"
            dark
            min-width="90"
            @click="addElement()"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-data-table
      :headers="headers"
      :items="items"
    >
      <template v-slot:item.unshare="{item}">
        <v-btn @click="removeElement(item)">
          {{ $t('delete') }}
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import { call } from 'vuex-pathify'

  export default {
    name: 'EditPlaneShare',
    props: {
      plane: Object,
    },
    data () {
      return {
        editedItem: null,
        open_edit: false,
      }
    },
    computed: {
      headers () {
        return [
          {
            align: 'start',
            value: 'id',
          },
          {
            value: 'name',
          },
          {
            value: 'start_date',
          },
          {
            value: 'end_date',
          },
          {
            value: 'unshare',
          },
        ]
      },
      items () { return this.plane.organizations.filter(p => !p.is_owner) },
    },
    methods: {
      share: call('plane/share'),
      unshare: call('plane/unshare'),
      openEdit () {
        this.editedItem = {
          organization_id: null,
          organization_type: 3,
          plane_id: this.plane.id,
          start_date: null,
          end_date: null,
          is_owner: false,
          is_valid: true,
        }
        this.open_edit = true
      },
      closeEdit () {
        this.editedItem = null
        this.open_edit = false
      },
      async addElement () {
        console.log(this.editedItem)
        await this.share(this.editedItem).then(response => {
          this.plane.organizations = response
          this.closeEdit()
        }).catch(e => {
        })
      },
      async removeElement (item) {
        item.plane_id = this.plane.id
        await this.unshare(item).then(response => {
          this.plane.organizations.splice(this.plane.organizations.indexOf(item), 1)
        }).catch(e => {
        })
      },
    },
  }
</script>
